import {
    isTestMember,
    isVipMember,
    type MemberDataFirestoreRecord,
} from "@albertine/types";
import React from "react";
import { MemberAvatar } from "../Common/Avatar";
import "./MobileMemberViewHeader.css";
import { MemberMarkers } from "@prototypes/member-markers/MemberMarkers";
import { Flex } from "../Common/Flex";

type Props = {
    member: MemberDataFirestoreRecord | undefined;
};

function MobileMemberViewHeader(props: Props) {
    const { member } = props;
    if (!member) return null;
    return (
        <Flex.Row
            className="mobile-view__member-header"
            gap="large"
            // justifyContent="space-between"
        >
            <MemberAvatar
                memberId={member.id}
                alt={`${member.firstName} ${member.lastName}`}
                size="mid"
            />
            <Flex.Row gap="xsmall">
                {`${member.firstName} ${member.lastName}`}
                <MemberMarkers
                    isTestMember={isTestMember(member)}
                    isVipMember={isVipMember(member)}
                />
            </Flex.Row>
        </Flex.Row>
    );
}

export default MobileMemberViewHeader;
